import type { ReactElement } from 'react';

interface PhoneFrameProps {
  children: ReactElement[];
}

export function PhoneFrame({
  children,
}: PhoneFrameProps): ReactElement {
  return (
    <div style={{
      maxWidth: 330,
      border: '10px solid black',
      borderRadius: 50,
      padding: 15,
      paddingTop: 30,
      minHeight: 200,
    }}>
      {children}
    </div>
  );
}
